import style from '../CreditOnboardingEgyptLuckyV1/CreditOnboardingEgyptLuckyV1.css';
import Button from '../../shared/Button/Button';
import useTranslation from '../../../localization/i18n.context';
import Title from '../../shared/Typography/Title';
import List from '../../shared/List/List';
import ListItem from '../../shared/List/ListItem';
import { useState, useEffect } from 'preact/hooks';

const StepField = {
  RESIDENTIAL_STATUS: 'residentialStatus',
};

export default function ResidentialStatusStep({
  onInputChange,
  onButtonClick,
  data = {},
  types = [],
  stepNumber,
  stepCount,
}) {
  const [selectedValue, setSelectedValue] = useState(null);
  const { t } = useTranslation();
  const isButtonEnabled = Object.values(StepField).every(
    field => data[field] && data[field].value && data[field].value?.trim(),
  );

  useEffect(() => {
    updateSelectedValues(data);
  }, [data, types]);

  function updateSelectedValues(formData) {
    if (formData[StepField.RESIDENTIAL_STATUS]) {
      setSelectedValue(formData[StepField.RESIDENTIAL_STATUS].value ?? null);
    }
  }

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-header']}>
          <p className={style['form-header-title']}>
            {t(`STEP {step_number}/{step_count}`, {
              '{step_number}': stepNumber,
              '{step_count}': stepCount,
            })}
          </p>
        </div>
        <div className={style['form-title']}>
          <Title text={t("What's your current residential status?")} />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <List>
              {types.map((item, index) => (
                <ListItem
                  selected={selectedValue === item.id}
                  title={t(item.name)}
                  actionable
                  type={ListItem.Type.CHECKBOX}
                  size={ListItem.Size.SMALL}
                  onClick={() => {
                    setSelectedValue(item.id);
                    onInputChange({
                      target: {
                        name: StepField.RESIDENTIAL_STATUS,
                        value: item.id,
                      },
                    });
                  }}
                />
              ))}
            </List>
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth onClick={onButtonClick} disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
ResidentialStatusStep.Type = 'ResidentialStatusStep';
ResidentialStatusStep.EventName = 'residential_status_step';
